import React, { useState } from "react";
import { ActionPanel } from "components/panel";
import { Button } from "components/buttons";
import { LicenceCheckingLicenceConflictModal } from "pages/licence-checking/shared/licence-conflict";
import PropTypes from "prop-types";

export function ConflictingDetailsPanel({ checkData, reloadCheck }) {
    const [showModal, setShowModal] = useState(false);

    function handleSuccess() {
        setShowModal(false);
        reloadCheck();
    }

    return (
        <div className="spacer-top">
            <ActionPanel intent="warning" title="Conflicting Details">
                <p className="spacer-bottom">
                    There are conflicting details between the Licence Driver
                    Declaration and records on Vision. Do you want to approve
                    the current consent and proceed with the check or restart
                    the driver declaration process? Approving this consent will
                    not update Vision’s existing record.
                </p>

                <Button
                    id="add-question-type"
                    onClick={() => setShowModal(true)}
                    text={"Compare conflicts"}
                    icon="reset"
                    intent="Danger"
                />
            </ActionPanel>

            <LicenceCheckingLicenceConflictModal
                key={checkData?.employeeId}
                isOpen={showModal}
                existingLicenceNumber={
                    checkData?.licence?.existingLicenceNumber
                }
                consentLicenceNumber={checkData?.licence?.licenceNumber}
                employeeName={checkData?.employeeName}
                onClose={() => setShowModal(false)}
                onSuccess={handleSuccess}
                employeeId={checkData?.employeeId}
                emailAddress={checkData?.emailAddress}
                consentId={checkData?.licence?.declarationId}
                licenceNumberOverridable={
                    checkData?.licence?.canCopyLicenceNumber
                }
            />
        </div>
    );
}

ConflictingDetailsPanel.propTypes = {
    checkData: PropTypes.object.isRequired,
    reloadCheck: PropTypes.func.isRequired,
};
